// @ts-check
import React from 'react';
import classNames from 'classnames';
import { graphql } from 'gatsby';

export const query = graphql`
	fragment CustomDebitCardFragment on Ozk_content_blockModular_blocksCopyContent {
		custom_debit_card_design_iframe {
			heading
		}
	}
`;

/**
 * @typedef CustomDebitCardDesignIframeProps
 * @property {string} heading
 * 
 * @param {{ options: CustomDebitCardDesignIframeProps }} props
 */
/** @type {import('~/types/React').ReactFC<CustomDebitCardDesignIframeProps>} */
const CustomDebitCardDesignIframe = ({ heading, ...rest }) => {
	return (
		<div {...rest} className={classNames(rest.className, 'custom-debit-card-design-iframe')}>
			<iframe
				title="Card Designer"
				className="custom__frame d-none d-sm-none d-md-none d-lg-block"
				width="800"
				height="600"
				style={{ margin: '50px auto' }}
				frameBorder="0"
				sandbox="allow-scripts allow-forms allow-same-origin"
				src="https://us.personalcard.net/AllAboutMe/Designer/PCS/Start.aspx?Handover_Key=84d47f9b-0f47-4cf6-8c95-854d215355ad"
			/>
			<a
				href="https://us.personalcard.net/AllAboutMe/Designer/PCS/Start.aspx?Handover_Key=84d47f9b-0f47-4cf6-8c95-854d215355ad&LanguageId=en-US"
				className="btn btn--primary btn--upper btn--full custom__button d-sm-inline-flex d-md-inline-flex d-lg-none"
			>
				Create Your Card Now
			</a>
		</div>
	);
};

export default CustomDebitCardDesignIframe;
